import React from 'react';
import { useContext } from 'react';
import { useReducer } from 'react';

const ExpandedViewContext = new React.createContext();
const ExpandedViewDispatchContext = new React.createContext();

export function useExpandedView() {
    return useContext(ExpandedViewContext);
}

export function useExpandedViewDispatch() {
    return useContext(ExpandedViewDispatchContext);
}

function expandedViewReducer(state, action) {
    switch (action.type) {
        default:
        case 'toggle': {
            return  {
                ...state,
                toggled: !state.toggled
            }
        }
    }
}

export default function ExpandedViewProvider(props) {
    const [toggled, dispatch] = useReducer(expandedViewReducer, {
        toggled: false
    });

    return (
        <ExpandedViewContext.Provider value={toggled}>
            <ExpandedViewDispatchContext.Provider value={dispatch}>
                {props.children}
            </ExpandedViewDispatchContext.Provider>
        </ExpandedViewContext.Provider>
    );
}
